<template>
  <el-row :gutter="20" v-if="mode == 'create'">
    <el-col :span="6" style="text-align: left;">
      <el-button size="large" type="success" round :icon="FolderAdd" @click="dialog = true;projectInfo.out_date = formatDate(new Date(), 'yyyy-MM-dd')">新建销售送货单</el-button>
    </el-col>
    <el-col :span="12" style="text-align: left;--el-border-color: var(--el-color-success)">
      <el-input
          v-model="keyword"
          style="width: 100%"
          placeholder="输入搜索关键字"
          clearable
          @input="search"
          size="large"
      >
        <template #prefix>
          <el-icon color="var(--el-color-success)">
            <Search/>
          </el-icon>
        </template>
      </el-input>
    </el-col>
    <el-col :span="6" style="text-align: left;">
      <el-date-picker
          v-model="range"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :size="'large'"
          value-format="YYYY-MM-DD"
          @change="search"
      />
    </el-col>
    <el-col :span="24">
      <el-divider/>
    </el-col>
  </el-row>
  <el-button v-if="mode == 'update'"  type="danger" round :icon="Edit" @click="dialog = true; findProject()">编辑</el-button>

  <el-dialog v-model="dialog" :close-delay="300" width="800px" top="0vh" center
             :close-on-click-modal="false"
  >
    <template #header>
      <p style="letter-spacing: 1px;">
        <el-tag size="large" round type="success" effect="plain" style="--el-tag-font-size: 15px;">
          <el-icon v-if="mode == 'update'">
            <Edit/>
          </el-icon>
          <el-icon v-else>
            <FolderAdd/>
          </el-icon>
          {{mode == 'update' ? '编辑销售送货单' : '创建销售送货单'}}
        </el-tag>
      </p>
    </template>
    <el-input v-model="projectInfo.order_id" readonly placeholder="提交后系统自动生成">
      <template #prepend>
        <div style="width: 85px;text-align: center">送货单号</div>
      </template>
    </el-input>
    <div style="margin-top: 25px" id="out_date">
      <el-date-picker
          v-if="mode == 'create'"
          v-model="projectInfo.out_date"
          type="date"
          placeholder="请选择送货日期(默认当天)"
          style="width: 100%;--el-input-focus-border-color:#dcdfe6"
          :prefix-icon="customPrefix"
          value-format="YYYY-MM-DD"
          format="YYYY-MM-DD"
      />
      <el-input v-model="projectInfo.out_date" readonly placeholder="默认当天" v-else>
        <template #prepend>
          <div style="width: 85px;text-align: center">送货日期</div>
        </template>
      </el-input>
    </div>
    <div style="margin-top: 25px">
      <el-input v-model="projectInfo.cname"  placeholder="请输入客户名称（必填）" show-word-limit maxlength="54">
        <template #prepend>
          <div style="width: 85px;text-align: center">客户名称<span style="color: #FF0000">*</span></div>
        </template>
      </el-input>
<!--      <p style="height: 32px;line-height: 32px;background-color: rgb(30, 159, 255);color: #f5f7fa;border: 1px solid #dcdfe6;text-align: center;letter-spacing: 1px;border-bottom: none">-->
<!--        客户名称 <span style="color: #f5f7fa">（必填）</span></p>-->
<!--      <el-input v-model="projectInfo.cname" placeholder="请输入客户名称（必填）" show-word-limit maxlength="54"-->
<!--                :autosize="{ minRows: 1, maxRows: 2 }" type="textarea" style="&#45;&#45;el-border-radius-base: 0px"/>-->
      <el-tag type="danger" effect="plain" style="visibility: hidden;margin-left: 125px" :style="errorData.name === 'cname' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>
    <div style="margin-top: 5px">
      <el-input v-model="projectInfo.salesman"  placeholder="请输入业务员名称（必填）" show-word-limit maxlength="26">
        <template #prepend>
          <div style="width: 85px;text-align: center">业务员名称<span style="color: #FF0000">*</span></div>
        </template>
      </el-input>
<!--      <p style="height: 32px;line-height: 32px;background-color: rgb(30, 159, 255);color: #f5f7fa;border: 1px solid #dcdfe6;text-align: center;letter-spacing: 1px;border-bottom: none">-->
<!--        业务员名称 <span style="color: #f5f7fa">（必填）</span></p>-->
<!--      <el-input v-model="projectInfo.salesman" placeholder="请输入业务员名称（必填）" show-word-limit maxlength="26"-->
<!--                :autosize="{ minRows: 1, maxRows: 2 }" type="textarea" style="&#45;&#45;el-border-radius-base: 0px"/>-->
      <el-tag type="danger" effect="plain" style="visibility: hidden;margin-left: 125px" :style="errorData.name === 'salesman' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>

    <div style="margin-top: 5px">
      <el-input v-model="projectInfo.plan"  placeholder="请输入生产计划内容" show-word-limit maxlength="54">
        <template #prepend>
          <div style="width: 85px;text-align: center">生产计划</div>
        </template>
      </el-input>
<!--      <p style="height: 32px;line-height: 32px;background-color: rgb(30, 159, 255);color: #f5f7fa;border: 1px solid #dcdfe6;text-align: center;letter-spacing: 1px;border-bottom: none">-->
<!--        生产计划 </p>-->
<!--      <el-input v-model="projectInfo.plan" placeholder="请输入生产计划内容" show-word-limit maxlength="54"-->
<!--                :autosize="{ minRows: 1, maxRows: 2 }" type="textarea" style="&#45;&#45;el-border-radius-base: 0px"/>-->
      <el-tag type="danger" effect="plain" style="visibility: hidden;margin-left: 125px" :style="errorData.name === 'plan' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>
    <div style="margin-top: 5px">
      <el-input v-model="projectInfo.remark"  placeholder="请输入备注信息" show-word-limit maxlength="26">
        <template #prepend>
          <div style="width: 85px;text-align: center">备注信息</div>
        </template>
      </el-input>
<!--      <p style="height: 32px;line-height: 32px;background-color: rgb(30, 159, 255);color: #f5f7fa;border: 1px solid #dcdfe6;text-align: center;letter-spacing: 1px;border-bottom: none">-->
<!--        备注信息</p>-->
<!--      <el-input v-model="projectInfo.remark" placeholder="请输入备注信息" show-word-limit maxlength="26"-->
<!--                :autosize="{ minRows: 1, maxRows: 2 }" type="textarea" style="&#45;&#45;el-border-radius-base: 0px"/>-->
      <el-tag type="danger" effect="plain" style="visibility: hidden;margin-left: 125px" :style="errorData.name === 'remark' ? 'visibility: visible' : ''"  size="small" round  >{{errorData.message}}</el-tag>
    </div>
    <template #footer>
      <el-button type="success" plain @click="onCreateProject" style="width: 90%" round :icon="FolderAdd" v-if="mode == 'create'">
        创建
      </el-button>
      <el-button type="success" plain @click="onUpdateProject" style="width: 90%" round :icon="Edit" v-if="mode == 'update'">
        更新
      </el-button>

      <div class="Page" style="height: 160px;margin-top: 20px">
        <div class="container" style="width: 20cm;margin-left: -1.5cm;">
          <h1 style="text-align: center;font-size: 19px;color: #67c23a">预览输入内容</h1>
          <table width="755" style="width: 755px;margin: -23px auto 0;border-collapse: collapse;text-align: center;color: #000;">
            <tbody>
            <!--        固定表格结构-->
            <tr style="visibility: hidden;color: transparent">
              <td style="padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
              <td colspan="2" style="padding: 4px 7px;width: 450px" width="450">ABCDEFGHIABCDEFGHIABCDEFGHIABCDEFGHIABCDEFGHIABCDEFGHI</td>
              <td style="padding: 4px 7px;width: 120px" width="120">ABCDEFGHGHGH</td>
              <td colspan="2" style="padding: 4px 7px; width: 210px" width="210">ABCDEFGHABCDEFGHABCDEFGHIJ</td>
            </tr>
            <tr>
              <td style="padding: 4px 7px;width: 80px;text-align: left" width="80" colspan="3">送货单号:{{projectInfo.order_id?.replace(/-/g,'')}}</td>
              <td style="padding: 4px 7px 4px 30px;width: 120px;text-align: left;" width="120" colspan="3">送货日期:{{projectInfo.out_date}}</td>
            </tr>
            <tr>
              <td style="border: 1px solid #333; padding: 4px 7px;width: 80px" width="80">客户名称</td>
              <td colspan="2" style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 450px" width="450">{{projectInfo.cname}}</td>
              <td style="border: 1px solid #333;border-left: none; padding: 4px 7px;width: 120px" width="120">业务员</td>
              <td colspan="2" style="border: 1px solid #333;padding: 4px 7px; width: 210px" width="210">{{projectInfo.salesman}}</td>
            </tr>
            <tr style="height: 24px;">
              <td style="border: 1px solid #333;border-top: none;padding: 4px 7px;width: 80px" width="80">生产计划</td>
              <td colspan="2" style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 450px" width="450">{{projectInfo.plan}}</td>
              <td style="border: 1px solid #333;border-left: none; border-top: none ;padding: 4px 7px;width: 120px" width="120">备注</td>
              <td colspan="2" style="border: 1px solid #333;border-top:none;padding: 4px 7px; width: 210px;">{{projectInfo.remark}}</td>
            </tr>
            <tr style="visibility: hidden;color: transparent">
              <td style="border: 1px solid transparent;border-top: none;padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 350px" width="350">ABCDEFGHGHABCDEFGHGHABCDEFGHGHABCDEFGHGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 100px" width="100">ABCDEFGHGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 120px" width="120">ABCDEFGHGHGHGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
              <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 130px" width="130">ABCDEFGHGHGHGH</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </template>


  </el-dialog>
</template>

<script setup>
import {Search, FolderAdd, Edit} from '@element-plus/icons-vue';
import {defineEmits, reactive, ref, defineProps, watch, shallowRef, h} from "vue";
import _ from "lodash";
import {configObjectNull, get, post} from "@/assets/js/utils";
import {formatDate} from "date-fns";
const props = defineProps(['mode', 'id', 'initValue'])
const dialog = ref(false)
const keyword = ref(props.initValue ? props.initValue.keyword : '');
const range = ref(props.initValue ? props.initValue.range : '')
const emits = defineEmits(['search', 'createdProject', 'updatedProject'])
const projectInfo = reactive({
  cname: null,
  salesman: null,
  plan: null,
  reviewer: null,
  order_id: null,
  out_date: null,
  remark: null,
})
const customPrefix = shallowRef({
  render() {
    return h('div', {style: {'font-style': 'normal', 'color': '#909399'}},'送货日期')
  },
})
const errorData = reactive({
  name:'',
  message: ''
})

watch(projectInfo, () => {
  errorData.name = ''
})

const delaySearch = _.debounce(() => {
  emits("search", keyword.value, range.value);
}, 1000, {maxWait: 3000})

function search() {
  delaySearch();
}

const onCreateProject = function () {
  let postData = {...projectInfo};
  post('/add', postData, ({message, code, data}) => {
    // ElMessage({
    //   message,
    //   type: code == 0 ? 'success' : 'info',
    //   duration: 10000
    // })
    if (code != 0){
      errorData.name = data.data;
      errorData.message = message;
      return;
    }
    emits("createdProject", data.data)
    configObjectNull(projectInfo, ['report_spec'])
    dialog.value = false;

  },null)
}


const onUpdateProject = function () {
  let postData = {...projectInfo};
  post('/update', postData, ({message, code, data}) => {
    // ElMessage({
    //   message,
    //   type: code == 0 ? 'success' : 'info',
    //   duration: 10000
    // })
    if (code != 0){
      errorData.name = data.data;
      errorData.message = message;
      return;
    }
    emits("updatedProject")
    configObjectNull(projectInfo, ['report_spec'])
    dialog.value = false;

  },null)
}

function findProject(){
  get('/find?id=' + props.id, ({code, data}) => {
    if (code == 0){
      Object.assign(projectInfo, data.data);
    }
  })
}


</script>

<style>
#out_date span.el-input__prefix-inner{
  width: 127px !important;
  background-color: #f5f7fa;
  margin-left: -11px;
  border-left: 1px solid #dcdfe6;
  border-right: 1px solid #dcdfe6;

}
#out_date .el-input__inner{
  padding-left: 7px !important;
}
</style>